import { TResultsSectionArray, TSectionArray } from "./validations.d";

const getIdentifier = (section: string[] | TSectionArray[]) => {
	if (JSON.stringify(section ?? {}).includes("commission")) {
		return "commission";
	}
	return "bonus";
};

const mergeErrorsMatrixValidation = (_: unknown, section: string[]) => {
	const identifier = getIdentifier(section);
	if (section?.length === 1 && section?.[0]?.length === 1) {
		return [[{ [identifier]: true }]];
	}
	return [];
};

const mergeErrorsBonusesValidation = (results: Map<string, TResultsSectionArray[]>, section: TSectionArray[]) => {
	if (!results?.size) {
		return [];
	}
	const identifier = getIdentifier(section);
	const rows = results?.get("ROWS") ?? [];

	if (section.length === 1 && section[0].length === 1) {
		return [...rows];
	}

	const firstValue = section?.[0]?.[0]?.[identifier]?.value;

	for (const row of section) {
		if (row.some((cell) => cell?.bonus?.value !== firstValue)) {
			return [...rows];
		}
	}

	return rows.map((row) => {
		return row.map(() => {
			return {
				[identifier]: true,
			};
		});
	});
};

export { mergeErrorsMatrixValidation, mergeErrorsBonusesValidation };
